import React from "react";
import "../styles/_accomodation.scss";
interface Props {}

const AccomodationGR: React.FC<Props> = (props) => {
  return (
    <div className="Accomodation padding100" id="accomodation">
      <div className="container">
        <h6>AL-MARE</h6>
        <h1>ΚΑΤΑΛΥΜΑ</h1>
        <div className="row justify-content-evenly g-0">
          <div className="col-lg-4 my-lg-0 my-4 col-12  p-3">
            <div className="wrapper">
              <div className="proba">
                <img src="accomodation1.jpg" alt="" className="accImage" />
              </div>
              <div className="textWrapper">
                <h3 className="mb-3">Ευκολία</h3>
                <p>
                  Με απλό μοντέρνο σχεδιασμό και κομψή επίπλωση , τα δωμάτια στο
                  "Αλ Μάρε" παρέχει ένα χώρο άνεσης και χαλάρωσης .
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 my-lg-0 my-4 col-12  p-3">
            <div className="wrapper">
              <div className="proba">
                <img src="accomodation2.jpg" alt="" className="accImage" />
              </div>
              <div className="textWrapper">
                <h3 className="mb-3">Κατάλυμα</h3>
                <p>
                  Εξοπλισμένα είτε με ένα king-size κρεβάτι ή με δύο μονά
                  κρεβάτια , όλα τα δωμάτια μας προσφέρουν το σύστημα
                  κλιματισμός, τουαλέτα, ντους , δορυφορική τηλεόραση και ψυγείο
                  . Όλα τα δωμάτια του "Αλ Μάρε" έχουν ανοιχτά μπαλκόνια του
                  αέρα και κάποια από αυτά προσφέρουν θέα στον κόλπο του "Αλ
                  Μάρε" και την όμορφη πεντακάθαρη γαλάζια θάλασσα που κάνουν
                  αυτά τα δωμάτια αποπλανητικά, γοητευτικά και ελκυστικά.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 my-lg-0 my-4 col-12  p-3">
            <div className="wrapper">
              <div className="proba">
                <img src="accomodation3.jpg" alt="" className="accImage" />
              </div>
              <div className="textWrapper">
                <h3 className="mb-3">πρόγευμα</h3>
                <p>
                  Η διαμονή σας μπορεί να είναι σε βάση τους BB (ύπνο και
                  πρόγευμα) και HB (ημιδιατροφή / πρωινό και δείπνο).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccomodationGR;
